import { CustomerType, ProductType } from "@core/contracts/data-contracts";

export interface FilterableWidget {
  visibleForCustomer?: CustomerType;
  visibleForProduct?: ProductType;
}

export function isWidgetVisible(
  widget: FilterableWidget,
  activeProduct: ProductType,
  isB2B: boolean,
): boolean {
  const targetProduct = widget.visibleForProduct ?? ProductType.Mobile;
  const targetCustomer = widget.visibleForCustomer ?? CustomerType.B2C;

  const matchedProduct =
    targetProduct === ProductType.All ||
    activeProduct === targetProduct;

  const matchedCustomer =
    targetCustomer === CustomerType.All ||
    (isB2B ? targetCustomer === CustomerType.B2B : targetCustomer === CustomerType.B2C);

  return matchedProduct && matchedCustomer;
}